<pagination-template #api="paginationApi" (pageChange)="changePage($event)">
  @if (api.pages.length > 1) {
    @if (pageData && pageData.numberOfElements > 0) {
      <div
        class="pagination-overview-count"
        >
        <strong>{{ pageData.number * pageData.size + 1 }}</strong>
        -
        <strong>{{
          pageData.number * pageData.size + pageData.numberOfElements
        }}</strong>
      </div>
    }
    <div #template class="custom-template">
      @if (pageData) {
        <ul
          aria-label="Pagination"
          class="ng2-pagination"
          role="navigation"
          >
          @if (!api.isFirstPage()) {
            <li class="pagination-previous noviflora">
              <a (click)="api.previous()" aria-label="Previous page">
                <svg class="icon-pagination-prev" height="10" width="6">
                  <use
                    xlink:href="/images/icons/svg-sprite.svg#pagination-prev"
                  ></use>
                </svg>
              </a>
            </li>
          }
          @for (page of api.pages; track page) {
            <li
              [class.current]="api.getCurrent() === page.value"
              >
              @if (api.getCurrent() !== page.value) {
                <a
                  (click)="api.setCurrent(page.value)"
                  >
                  <span>{{ page.label }}</span>
                </a>
              }
              @if (api.getCurrent() === page.value) {
                <div>
                  <form
                    (ngSubmit)="onChangePageSubmit(pageData.totalPages)"
                    [formGroup]="paginationForm"
                    class="pagenumber-input-container"
                    >
                    <input
                      [formControl]="paginationForm.controls['pageNumber']"
                      [placeholder]="page.value"
                      type="number"
                      />
                    <button type="submit">
                      <svg
                        class="icon-search"
                        height="16"
                        viewBox="0 0 16 16"
                        width="16"
                        >
                        <use xlink:href="/images/icons/svg-sprite.svg#search"></use>
                      </svg>
                    </button>
                  </form>
                </div>
              }
            </li>
          }
          @if (!api.isLastPage()) {
            <li class="pagination-next noviflora">
              @if (!api.isLastPage()) {
                <a (click)="api.next()" aria-label="Next">
                  <svg class="icon-pagination-next" height="10" width="6">
                    <use
                      xlink:href="/images/icons/svg-sprite.svg#pagination-next"
                    ></use>
                  </svg>
                </a>
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</pagination-template>
